import React from "react";
import styled from "styled-components/macro";
import { NavLink } from "react-router-dom";

import {
  Avatar as MuiAvatar,
  Drawer as MuiDrawer,
  Grid,
  ListItemButton,
} from "@mui/material";

import Footer from "./SidebarFooter";
import SidebarNav from "./SidebarNav";
import useAuth from "../../hooks/useAuth";
import { SportsEsports } from "@mui/icons-material";
import SidebarAppDropdown from "./SidebarAppDropdown";

const Drawer = styled(MuiDrawer)`
  border-right: 0;

  > div {
    border-right: 0;
  }
`;

const SidebarHeader = styled(Grid)`
  color: ${(props) => props.theme.sidebar.header.color};
  background-color: ${(props) => props.theme.sidebar.header.background};
`;

const Brand = styled(ListItemButton)`
  font-size: ${(props) => props.theme.typography.h6.fontSize};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  font-family: ${(props) => props.theme.typography.fontFamily};
  min-height: 56px;
  padding-left: ${(props) => props.theme.spacing(6)};
  padding-right: ${(props) => props.theme.spacing(6)};
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex-grow: 0;

  ${(props) => props.theme.breakpoints.up("sm")} {
    min-height: 64px;
  }

  &:hover {
    background-color: ${(props) => props.theme.sidebar.header.background};
  }
`;

const Avatar = styled(MuiAvatar)`
  display: inline-flex;
  height: 40px;
  width: 40px;
  margin-right: ${(props) => props.theme.spacing(2)};
  border-radius: unset;
`;

const GameIcon = styled(SportsEsports)`
  width: 75%;
  height: 75%;
`;

const Sidebar = ({ items, showFooter = true, ...rest }) => {
  const { app } = useAuth();

  return (
    <Drawer variant="permanent" {...rest}>
      <SidebarHeader
        container
        spacing={2}
        justifyContent="space-between"
        flexWrap="nowrap"
        alignItems="center"
      >
        <Grid item>
          <Brand component={NavLink} to="/">
            <Avatar alt={app?.name} src={app?.logo}>
              <GameIcon />
            </Avatar>
            {app?.name}
          </Brand>
        </Grid>
        <Grid item>
          <SidebarAppDropdown />
        </Grid>
      </SidebarHeader>
      <SidebarNav items={items} />
      {!!showFooter && <Footer />}
    </Drawer>
  );
};

export default Sidebar;
